export class NotificationState {
    notificationSeverity?: NotificationSeverity;
    title?: string;
    message?: string;
    dismissButtonLabel?: string;
    closable?: boolean;
}

export enum NotificationSeverity {
    INFO = 'info',
    WARN = 'warn',
    SUCCESS = 'success',
    ERROR = 'error'
}
